import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import store from '../store';
import { logout, type SignOutNotice } from '../store/slices/authSlice';

/** Clears the server-side refresh token (best effort), then the local session. */
export const useSignOut = (): ((notice?: SignOutNotice) => Promise<void>) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    return useCallback(async (notice?: SignOutNotice) => {
        // The API identifies the session by its refresh token (the access token may have expired).
        await api.post('/auth/logout', { refreshToken: store.getState().auth.refreshToken }).catch(() => undefined);
        dispatch(logout(notice));
        navigate('/login', { replace: true });
    }, [dispatch, navigate]);
};
